// extracted by mini-css-extract-plugin
export default {"content":"delete-button_content__H1c56","tip":"delete-button_tip__5H5pw","text-bold":"delete-button_text-bold__MMddS"};